import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useScaleChecked } from '../../context/ScaleContext';
import { useJGraph } from './JGraphContext';
export default function JsCouplingLinks(props) {
    const { links } = props;
    const { scaleX } = useScaleChecked();
    const { scaleY, maxValue } = useJGraph();
    const generatePath = useCallback((link) => {
        if (!scaleY)
            return '';
        const { from, to, couplings } = link;
        let paths = [];
        for (const coupling of couplings) {
            paths.push(`M${scaleX()(from)},${scaleY(coupling.coupling)} L${scaleX()(to)},${scaleY(coupling.coupling)}`);
        }
        return paths.join(' ');
    }, [scaleX, scaleY]);
    return (_jsx("g", { className: "js-coupling-links", children: links
            .filter((link) => link.couplings.length > 1)
            .map((link) => {
            return (_jsx("path", { d: generatePath(link), style: {
                    stroke: `hsl(${(link.couplings[0].coupling * 360) / maxValue},100%,50%)`,
                }, strokeWidth: "1" }, link.id));
        }) }));
}
